import {
    CloudServerOutlined,
    AppstoreOutlined,
    ApiOutlined,
    PicLeftOutlined,
    AuditOutlined,
    GithubFilled,
    BugOutlined
} from '@ant-design/icons';
import { Menu } from 'antd';
import React, {useMemo} from 'react';
import {Link, useLocation, matchPath} from 'react-router-dom';
import classes from './Menu.module.css';
import MachineIcon from "../CustomIcons/MachineIcon";
import StaffIcon from "../CustomIcons/StaffIcon";
import ConstructorIcon from "../CustomIcons/MachineUserIcon";
import ProfileIcon from "../CustomIcons/ProfileIcon";
import TerminalDeviceIcon from "../CustomIcons/TerminalDeviceIcon";
import VRSServerIcon from "../CustomIcons/VRSServerIcon";
import SettingsIcon from "../CustomIcons/SettingsIcon";
import BranchIcon from "../CustomIcons/BranchIcon";
import {useTranslation} from "react-i18next";
import PermissionChecker from "../../PermissionChecker";
import {useData} from "../../DataContext";

// const { SubMenu } = Menu;

// Sidebar highlight config: each menu key with the route patterns that activate
// it. Patterns are matched with react-router's matchPath, so dynamic segments
// (e.g. '/machine/:id') and exact matching work the same way <NavLink> does.
const menuActivePatterns = [
    { key: 'profile', patterns: ['/user/profile'] },
    { key: 'constructor', patterns: ['/constructors', '/constructor/detail'] },
    { key: 'past-constructor', patterns: ['/past_constructors'] },
    { key: 'machine', patterns: ['/machines', '/machine/:id', '/machine/:id/:rentId'] },
    { key: 'vrs', patterns: ['/vrs_servers', '/vrs_server/detail'] },
    { key: 'user', patterns: ['/users', '/user/detail'] },
    { key: 'branch-settings', patterns: ['/branches'] },
    { key: 'terminal-devices', patterns: ['/terminal_devices', '/terminal_device/detail'] },
    { key: 'general-settings', patterns: ['/settings'] },
    { key: 'user-permissions', patterns: ['/user_permissions'] },
    { key: 'auth-apps', patterns: ['/auth_apps'] },
    { key: 'api-servers', patterns: ['/api_servers'] },
    { key: 'api-events', patterns: ['/api_events'] },
    { key: 'api-tasks', patterns: ['/api_tasks'] },
    { key: 'bucket-tool-configs', patterns: ['/bucket_tool_configs'] },
    { key: 'error-logs', patterns: ['/error_logs'] },
    { key: 'system-infos', patterns: ['/system_infos'] },
    { key: 'backup-restore', patterns: ['/auth/backups'] },
    { key: 'terminal-applications', patterns: ['/terminal_applications'] },
];

const getAdminMenu = (props, t) => {
    return [
        <Menu.Item key="profile" icon={<ProfileIcon/>} className={classes.menuItemStyle}>
            <Link to='/user/profile'>{t('menu_0')}</Link>
        </Menu.Item>,
        <Menu.Item key="constructor" icon={<ConstructorIcon />} className={classes.menuItemStyle}>
            <Link to='/constructors'>{t('menu_1')}</Link>
        </Menu.Item>,
        <Menu.Item key="past-constructor" icon={<ConstructorIcon />} className={classes.menuItemStyle}>
            <Link to='/past_constructors'>{t('menu_7')}</Link>
        </Menu.Item>,
        <Menu.Item key="machine" icon={<MachineIcon/>} className={classes.menuItemStyle}>
            <Link to='/machines'>{t('menu_2')}</Link>
        </Menu.Item>,
        <Menu.Item key="vrs" icon={<VRSServerIcon/>} className={classes.menuItemStyle}>
            <Link to='/vrs_servers'>{t('menu_6')}</Link>
        </Menu.Item>,
        <Menu.Item key="user" icon={<StaffIcon/>} className={classes.menuItemStyle}>
            <Link to='/users'>{t('menu_3')}</Link>
        </Menu.Item>,
        <Menu.Item key="branch-settings"  icon={<BranchIcon />} className={classes.menuItemStyle}>
            <Link to='/branches'>{t('menu_4')}</Link>
        </Menu.Item>,
        <Menu.Item key="terminal-devices"  icon={<TerminalDeviceIcon/>} className={classes.menuItemStyle}>
            <Link to='/terminal_devices'>{t('menu_8')}</Link>
        </Menu.Item>,
        <Menu.Item key="general-settings" icon={<SettingsIcon />} className={classes.menuItemStyle}>
            <Link to='/settings'>{t('menu_5')}</Link>
        </Menu.Item>,
    ];
}

const systemUserMenu = (props, t) => {
    return [
        <Menu.Item key="user-permissions" icon={<AuditOutlined/>} className={classes.menuItemStyle}>
            <Link to='/user_permissions'>User Permissions</Link>
        </Menu.Item>,
        <Menu.Item key="auth-apps" icon={<AppstoreOutlined style={{color: '#377EF3'}}/>} className={classes.menuItemStyle}>
            <Link to='/auth_apps'>Auth Apps</Link>
        </Menu.Item>,
        <Menu.Item key="api-servers" icon={<CloudServerOutlined style={{color: '#377EF3'}}/>} className={classes.menuItemStyle}>
            <Link to='/api_servers'>API Servers</Link>
        </Menu.Item>,
        <Menu.Item key="api-events" icon={<ApiOutlined style={{color: '#377EF3'}}/>} className={classes.menuItemStyle}>
            <Link to='/api_events'>API Events</Link>
        </Menu.Item>,
        <Menu.Item key="api-tasks" icon={<PicLeftOutlined style={{color: '#377EF3'}}/>} className={classes.menuItemStyle}>
            <Link to='/api_tasks'>API Tasks</Link>
        </Menu.Item>,
        <Menu.Item key="terminal-applications"  icon={<BranchIcon />} className={classes.menuItemStyle}>
            <Link to='/terminal_applications'>Terminal Applications</Link>
        </Menu.Item>,
        <Menu.Item key="bucket-tool-configs"  icon={<TerminalDeviceIcon style={{color: '#377EF3'}}/>} className={classes.menuItemStyle}>
            <Link to='/bucket_tool_configs'>Bucket Tool Configs</Link>
        </Menu.Item>,
        <Menu.Item key="error-logs" icon={<BugOutlined style={{color: '#377EF3'}}/>} className={classes
            .menuItemStyle}>
            <Link to='/error_logs'>Error Logs</Link>
        </Menu.Item>,
        <Menu.Item key="system-infos" icon={<GithubFilled style={{color: '#377EF3'}}/>} className={classes.menuItemStyle}>
            <Link to='/system_infos'>System Infos</Link>
        </Menu.Item>,
        <Menu.Item key="backup-restore" icon={<GithubFilled style={{color: '#377EF3'}}/>} className={classes.menuItemStyle}>
            <Link to='/auth/backups'>Backup and Restore</Link>
        </Menu.Item>,
    ];
}

const getUserMenu = (props, t) => {
    return [
        <PermissionChecker key="profile" requiredPermissions={['user-detail']}>
            <Menu.Item key="profile" icon={<ProfileIcon/>} className={classes.menuItemStyle}>
                <Link to='/user/profile'>{t('menu_0')}</Link>
            </Menu.Item>
        </PermissionChecker>,
        <PermissionChecker key="constructor" requiredPermissions={['available-constructor-list']}>
            <Menu.Item key="constructor" icon={<ConstructorIcon />} className={classes.menuItemStyle}>
                <Link to='/constructors'>{t('menu_1')}</Link>
            </Menu.Item>
        </PermissionChecker>,
        <PermissionChecker key="vrs" requiredPermissions={['machine-vrs-file-list']}>
            <Menu.Item key="vrs" icon={<VRSServerIcon/>} className={classes.menuItemStyle}>
                <Link to='/vrs_servers'>{t('menu_6')}</Link>
            </Menu.Item>
        </PermissionChecker>,
        <PermissionChecker key="machine" requiredPermissions={['machine-list']}>
            <Menu.Item key="machine" icon={<MachineIcon/>} className={classes.menuItemStyle}>
                <Link to='/machines'>{t('menu_2')}</Link>
            </Menu.Item>
        </PermissionChecker>,
        <PermissionChecker key="user" requiredPermissions={['user-list']}>
            <Menu.Item key="user" icon={<StaffIcon/>} className={classes.menuItemStyle}>
                <Link to='/users'>{t('menu_3')}</Link>
            </Menu.Item>
        </PermissionChecker>

    ];
}

function buildMenu(props, auth, t) {
    if(auth.is_superuser){
        return systemUserMenu(props, t)
    }
    else if( auth.is_admin){
        return getAdminMenu(props, t);
    }
    else {
        return getUserMenu(props, t);
    }
}

export const SiderMenu = ({props}) => {
    const {sharedData} = useData();
    const is_superuser = parseInt(sharedData.is_superuser||"0") || parseInt(window.sessionStorage.getItem('isSuperuser')||"0") || null;
    const is_adminuser = parseInt(sharedData.is_admin||"0") || parseInt(window.sessionStorage.getItem('isAdminUser')||"0") || null;
    const auth = {is_superuser: is_superuser, is_admin:is_adminuser}
    const { t } = useTranslation();
    let location = useLocation();
    
    const current = useMemo(() => {
        const match = menuActivePatterns.find(({ patterns }) =>
            patterns.some((pattern) => matchPath(pattern, location.pathname))
        );
        return match ? match.key : 'profile';
    }, [location.pathname]);

    const menus = buildMenu(props, auth, t);

    return (
        <Menu mode="inline" selectedKeys={[current]} className={classes.menu}>
            {menus}
        </Menu>
    );
};
